module.exports = __webpack_public_path__ + "media/images/sort_desc_disabled-27ac5d1bc294b1fae0564fe461a6304d.png";